import request from "@/util/request";

/* POST /sys/sys_user/login
账号登录 */
export const login = data => {
  return request({
    url: "/sys/sys_user/login",
    method: "post",
    data
  });
};

// /com/user/loginOut
// 退出登录
export const loginOut = params => {
    return request({
      url: "/com/user/loginOut",
      method: "get",
      params
    });
};

/* GET /sys/sys_user/getCode
    获取验证码图片 */
export const getCode = params => {
  return request({
    url: "/sys/sys_user/getCode",
    method: "get",
    params
  });
};
/* POST /com/user/updatePwd
    修改密码 */
export const updatePwd = data => {
  return request({
    url: "/com/user/updatePwd",
    method: "post",
    data
  });
};
/* POST /com/user/getForgetPasswordLogin
    找回密码下一步验证 */
export const getForgetPasswordLogin = data => {
  return request({
    url: "/com/user/getForgetPasswordLogin",
    method: "post",
    data
  });
};
/* POST /com/user/getForgetPasswordVerification
    找回密码获取手机验证码 */
export const getForgetPasswordVerification = data => {
  return request({
    url: "/com/user/getForgetPasswordVerification",
    method: "post",
    data
  });
};
/* GET /sys/sys_user/getForgetPasswordVerificationCode
    找回密码 -- 获取图形验证 */
export const getForgetPasswordVerificationCode = params => {
  return request({
    url: "/sys/sys_user/getForgetPasswordVerificationCode",
    method: "get",
    params
  });
};
/* GET /sys/sys_user/verifyAccount
    找回密码 -- 输入账号账号 */
export const verifyAccount = params => {
  return request({
    url: "/sys/sys_user/verifyAccount",
    method: "get",
    params
  });
};
/* GET /sys/sys_user/sendVerifyCode
    找回密码 -- 发送短信验证码 */
export const sendVerifyCode = params => {
  return request({
    url: "/sys/sys_user/sendVerifyCode",
    method: "get",
    params
  });
};
/* POST /sys/sys_user/getForgetPasswordVerification
    找回密码 -- 安全验证 */
export const passwordVerification = data => {
  return request({
    url: "/sys/sys_user/getForgetPasswordVerification",
    method: "post",
    data
  });
};
/* POST /sys/sys_user/updatePasswordByForget
    找回密码 -- 修改密码 */
export const updatePasswordByForget = data => {
  return request({
    url: "/sys/sys_user/updatePasswordByForget",
    method: "post",
    data
  });
};

// GET /sys/content/getContentById
// 根据id查看新闻详情
export const getContentById = params => {
  return request({
    url: "/sys/content/getContentById",
    method: "get",
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/login/index.js